import HolidayProgramBookingJson from './HolidayProgramBookingJson';
import HolidayProgramPriceJson, { validateHolidayProgramPriceJson } from './HolidayProgramPriceJson';
import { Validation } from './Validation';

/**
 * Termin von einem Kurs der von der Jugendfarm angeboten wird
 */
export default interface WorkshopDateJson {
   beginDateTime: string;
   endDateTime: string;
}


export function validateWorkshopDateJson(item: WorkshopDateJson) {
   return new Validation(item)
      .validateDate("beginDateTime")
      .validateDateLater("endDateTime", "beginDateTime")
      .finish();
}